export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes60_sell.6b12817e.mp3";